const services = [
	{
		path: '/ai/services/list',
		name: 'ai-services-list',
		component: () => import('@/views/ai/services/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAI,services',
		},
	},
]

export default services
